import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import ArrowBack from '@mui/icons-material/ArrowBack';

import api, { authHeader } from '../../../../../../services/API/apiConfig';

import { DialogBox } from '../../../../../components/singleComponents/dialogs/DialogBox';
import { Dropzone } from '../../../../../components/singleComponents/dropzone/Dropzone';
import { NewFolder } from '../../../../../components/singleComponents/modals/NewFolder';
import ToasterBox from '../../../../../components/singleComponents/toaster/ToasterBox';
import { TableFolder } from './TableFolder';

import GlobalContext from '../../../../../../context/GlobalContext';
import {
  BtnFolderStyled,
  CompanyNameStyled,
  ContainerFolderNameStyled,
  DefaultPageStyled,
  HeaderPageStyled,
  IconStyled,
  LoaderContainerStyled,
  LoadingProgressStyled,
  RootStyled,
  UploadContainerStyled,
} from './ConstructionDocuments.styles';

const header = [' ', 'Pasta', 'Data da última modificação'];
const row = ['name', 'last_modified'];

export function ConstructionDocuments() {
  const {
    companyData: { subdomain },
  } = useContext(GlobalContext);

  const { id } = useParams();

  const baseURL = process.env.REACT_APP_API;
  const protocol = subdomain.endsWith('-st') ? 'http' : 'https';

  const [construction, setConstruction] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [titleModal, setTitleModal] = useState('Nova pasta');
  const [folders, setFolders] = useState([]);
  const [foldersShow, setFolderShow] = useState(true);
  const [folderDocuments, setFolderDocuments] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState([]);
  const [folderId, setFolderId] = useState(null);
  const [rowId, setRowId] = useState(null);
  const [showToaster, setShowToaster] = useState(false);
  const [toasterMessage, setToasterMessage] = useState('');
  const [openDialogFolder, setOpenDialogFolder] = useState(false);
  const [openDialogDocument, setOpenDialogDocument] = useState(false);
  const [rowIdDocument, setRowIdDocument] = useState(null);
  const [isUploading, setUploading] = useState(false);

  const [loading, setLoading] = useState(true);

  const handleCreateNewFolder = () => {
    setFolderId(null);
    setOpenModal(!openModal);
  };

  const getFolders = async () => {
    await api
      .get(`constructions/${id}/document-folders`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(true);
        setFolders(data);
        setLoading(false);
      });
  };

  const editFolderName = (idRow) => {
    setTitleModal('Editar nome da pasta');
    setFolderId(idRow);
    setOpenModal(!openModal);
  };

  const deleteFolder = async (idRow) => {
    await api
      .delete(`/folders/${idRow}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { status, messages } = res.data;
        if (status === 0) {
          setToasterMessage(messages);
          setShowToaster(true);
          getFolders();
          setOpenDialogFolder(false);
        }
      });
  };

  const getDocuments = async () => {
    if (selectedFolder.id) {
      await api
        .get(`/folders/${selectedFolder.id}/documents`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setFolderDocuments(data);
          setUploading(false);
        });
    }
  };

  const deleteDocument = async (documentId) => {
    await api
      .delete(`/documents/${documentId}`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { status, messages } = res.data;
        if (status === 0) {
          setToasterMessage(messages);
          setShowToaster(true);
          getDocuments();
          setOpenDialogDocument(false);
        }
      });
  };

  const returnId = async (idRow) => {
    setSelectedFolder(idRow);

    await api
      .get(`/folders/${idRow.id}/documents`, {
        headers: authHeader(),
      })
      .then((res) => {
        const { data } = res.data;
        setFolderShow(false);
        setFolderDocuments(data);
      });
  };

  const handleDisplayFile = async (fileId) => {
    window.open(`${protocol}://${subdomain}.${baseURL}${fileId.path.url}`);
  };

  useEffect(() => {
    const getConstruction = async () => {
      await api
        .get(`/constructions/${id}`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;
          setConstruction(data);
        });
    };
    getConstruction();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      getFolders();
    }, 2500);
  }, []);

  useEffect(() => {
    if (!isUploading) {
      setTimeout(() => {
        getDocuments();
      }, 1000);
    }
  }, [isUploading]);

  return (
    <>
      {showToaster && <ToasterBox message={toasterMessage} />}
      <Paper style={{ minHeight: 550 }}>
        <RootStyled>
          <HeaderPageStyled>
            <CompanyNameStyled variant="h1">
              {construction.name}
            </CompanyNameStyled>
            <UploadContainerStyled>
              {!foldersShow ? (
                <>
                  <Dropzone
                    route={`/folders/${selectedFolder.id}/documents`}
                    setUploading={setUploading}
                    setFile={() => {}}
                  />
                  {isUploading && (
                    <LoaderContainerStyled>
                      <CircularProgress size={28} />
                    </LoaderContainerStyled>
                  )}
                </>
              ) : (
                <BtnFolderStyled
                  id="create-folder"
                  color="secondary"
                  variant="contained"
                  onClick={handleCreateNewFolder}
                >
                  Criar pasta
                </BtnFolderStyled>
              )}
            </UploadContainerStyled>
          </HeaderPageStyled>
          {loading ? (
            <LoadingProgressStyled>
              <Typography variant="h2">Carregando...</Typography>
              <LinearProgress style={{ width: '80%' }} />
            </LoadingProgressStyled>
          ) : (
            <>
              <ContainerFolderNameStyled>
                {!foldersShow && (
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    startIcon={<ArrowBack />}
                    onClick={() => setFolderShow(true)}
                  >
                    Retornar para lista de pastas
                  </Button>
                )}
              </ContainerFolderNameStyled>
              {!foldersShow && (
                <TableFolder
                  data={folderDocuments}
                  headings={header}
                  keys={row}
                  editActions
                  foldersShow={foldersShow}
                  buttonDeleteFunction={(fileId) => {
                    setRowIdDocument(fileId);
                    setOpenDialogDocument(!openDialogDocument);
                  }}
                  callbackClickRow={handleDisplayFile}
                />
              )}
              {foldersShow && (
                <TableFolder
                  data={folders}
                  headings={header}
                  keys={row}
                  editActions
                  foldersShow={foldersShow}
                  buttonEditFunction={editFolderName}
                  buttonDeleteFunction={(selectedFolderId) => {
                    setOpenDialogFolder(!openDialogFolder);
                    setRowId(selectedFolderId);
                  }}
                  callbackClickRow={returnId}
                />
              )}
              {!folders.length && (
                <DefaultPageStyled>
                  <IconStyled />
                  <Typography style={{ fontSize: '12px' }}>
                    Nenhuma pasta foi adicionada até o momento
                  </Typography>
                </DefaultPageStyled>
              )}
            </>
          )}
        </RootStyled>
      </Paper>
      <NewFolder
        title={titleModal}
        open={openModal}
        folderId={folderId}
        kind="document"
        onClose={() => setOpenModal(!openModal)}
        runAfterSave={() => getFolders()}
      />
      <DialogBox
        title="Remover pasta"
        content="Deseja realmente remover esta pasta? Esta ação não poderá ser desfeita"
        openDialog={openDialogFolder}
        closeDialog={() => setOpenDialogFolder(!openDialogFolder)}
        mainAction={() => deleteFolder(rowId)}
      />
      <DialogBox
        title="Remover documento"
        content="Deseja realmente remover este arquivo? Esta ação não poderá ser desfeita"
        openDialog={openDialogDocument}
        closeDialog={() => setOpenDialogDocument(!openDialogDocument)}
        mainAction={() => deleteDocument(rowIdDocument)}
      />
    </>
  );
}
